import { render, staticRenderFns } from "./EditEmployeeComponent.vue?vue&type=template&id=6f3368ea&scoped=true"
import script from "./EditEmployeeComponent.vue?vue&type=script&lang=js"
export * from "./EditEmployeeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3368ea",
  null
  
)

export default component.exports